export const constants = {
	selector: {
		target: '.js-tooltip-select',
		saveData: 'data-tooltip-select-selected-data',
	},
}
